import { getFullStory, isFullStoryInstalled } from '.';

// Note that custom vars need to be type-suffixed (e.g. _str for strings).
// See "Custom fields" section of this doc for more info: https://help.fullstory.com/develop-js/setuservars
export const setFullStoryUserVars = (userVars: { [key: string]: any }) => {
  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  getFullStory().setUserVars(userVars);
};
